import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import locationService from '../services/locationService'
import LocationMap from '../components/LocationMap'
import Spinner from '../components/Spinner'

const useStyles = makeStyles(theme => ({
    paper: {
      padding:10,
    },
    map: {
        maxHeight: 500,
    },
    button: {
        marginTop:10,
    },
  }));

function Locate(props) {
    const classes = useStyles();
    const itemState = useSelector(state => state.item)
    const [location, setLocation] = useState({})
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        locationService(itemState.item['id-biblioteca'], itemState.item['numero-chamada'])
        .then(({data}) => {
            setLocation({...data, library: itemState.item['id-biblioteca'],})
            setLoading(false)   
        })
        .catch(() => setLoading(false))
    // eslint-disable-next-line react-hooks / exhaustive-deps
    }, [])

    return (
        <Box display="flex">
            <Box flexGrow={1} p={1}>
                <Paper className={classes.paper}>
                    <Typography variant="h5">{location.floor_description}</Typography>
                    <Typography color="textPrimary" variant="subtitle1">{itemState.item.titulo}</Typography>
                    <Typography color="textSecondary" variant="subtitle2">Localização: {itemState.item['numero-chamada']}</Typography>

                    <Box display="flex" justifyContent="center">
                        <Box pt={2}>
                            {loading ? <Spinner /> : <LocationMap location={location} /> }
                        </Box>
                    </Box>
                    <Button
                        color="primary" 
                        fullWidth={true} 
                        className={classes.button}
                        onClick={() => props.history.goBack()}
                    >
                        Voltar
                    </Button>
                </Paper>
            </Box>
        </Box>
    );
}
  
export default Locate;